var SCM = SCM || {};

SCM.SeamlessAccess = (function ($) {
	var persistenceService;
	var discoveryService;
	var persistenceContext;
	var isInitialized = false;
	var currentCheckboxSelector = null;

	return {
		init: _init,
		saveShibbolethID: saveShibbolethID,
		latestShibboleth: latestShibboleth,
		removeShibbolethID: removeShibbolethID,
		initialized: initialized,
		updateCheckboxSelector: updateCheckboxSelector
	};

	function _init() {
		SCM.Retry.policy()
			.handleResult(function (result) { return !result; })
			.waitAndRetry(5, 500)
			.execute(function () {
				return thissInitialized();
			})
			.then(function (result) {
				initializeSeamless();
			})
			.catch(function (reason) {
				console.error('SCM.SeamlessAccess - timed out waiting for thiss to be ready.');
			});
	}

	function thissInitialized() {
		return thiss && thiss.PersistenceService && thiss.DiscoveryService;
	}

	function initializeSeamless() {
		persistenceContext = 'seamlessaccess.org'; /* change this context value to persist entities in your own context (i.e. key). */
		
		// Always create persistenceService for existing functionality
		persistenceService = new thiss.PersistenceService('https://service.seamlessaccess.org/ps/');
		
		// Check if checkbox holder exists for Storage Access API
		var checkboxSelector = getCheckboxSelector();
		
		if (checkboxSelector && !discoveryService) {
			// Initialize with Storage Access API support - only once
			discoveryService = new thiss.DiscoveryService(
				'https://md.seamlessaccess.org/entities/',
				'https://service.seamlessaccess.org/ps/',
				persistenceContext,
				{
					selector: checkboxSelector
				}
			);

			currentCheckboxSelector = checkboxSelector;
		} else if (!discoveryService) {
			// Fallback to legacy initialization - only if no DiscoveryService exists
			discoveryService = new thiss.DiscoveryService('https://md.seamlessaccess.org/entities/',
				'https://service.seamlessaccess.org/ps/', persistenceContext);
		}

		isInitialized = true;
	}

	function updateCheckboxSelector(newSelector) {
		// Only update if the selector has changed and we have a DiscoveryService
		if (discoveryService && discoveryService.ps && newSelector !== currentCheckboxSelector) {
			// Remove existing iframe
			if (currentCheckboxSelector) {
				$(currentCheckboxSelector + ' iframe').remove();
			}
			
			// Update the checkbox selector
			if (discoveryService.ps.show_checkbox) {
				discoveryService.ps.show_checkbox(newSelector);
				currentCheckboxSelector = newSelector;
			}
		}
	}

	function getCheckboxSelector() {
		// Check for checkbox holder in the DOM
		if ($('#ps-checkbox-holder-header').length > 0) {
			return '#ps-checkbox-holder-header';
		}
		if ($('#ps-checkbox-holder-panel').length > 0) {
			return '#ps-checkbox-holder-panel';
		}
		return null;
	}

	function initialized() {
		return isInitialized;
	}

	//internal routine to sort entities by most recent.
	//last_use can be missing on some persisted entities; treat a missing value as oldest
	//so the comparator never returns NaN (which would leave the list in insertion order).
	function compareByMostRecentLastUse(a, b) {
		return (b.last_use || 0) - (a.last_use || 0);
	}

	//This saves a shibboleth ID and calls back to function passed in
	//It looks up the entity information to persist in the seamless access entity storage
	function saveShibbolethID(shibbolethID, preferredTitle) {
		return waitForThiss()
			.then(function (result) {
				if (!isInitialized) {
					initializeSeamless();
				}

				return discoveryService.mdq(shibbolethID).then(function (entity) {
					if (!entity) {
						//Create entity if we can not discover it
						entity = createDefaultEntity(shibbolethID, preferredTitle);
					}
					return saveEntity(entity, preferredTitle);
				});
			});
	}

	function waitForThiss() {
		return SCM.Retry.policy()
			.handleResult(function (result) { return !result; })
			.waitAndRetry(5, 500)
			.execute(function () {
				return thissInitialized();
			})
			.catch(function (reason) {
				console.error('waitForThiss - timed out waiting for thiss to be ready.');
			});
    }

	function createDefaultEntity(shibbolethID, preferredTitle) {
		return {
			"entity_icon": "",
			"descr": preferredTitle,
			"title": preferredTitle,
			"name_tag": preferredTitle,
			"type": "idp",
			"auth": "other",
			"entity_id": shibbolethID,
			"entityID": shibbolethID,
			"hidden": "",
			"scope": "",
			"id": shibbolethID
		};
	}

	//This removes a shibboleth ID and calls back to function passed in
	//It looks up the entity information to persist in the seamless access entity storage and removes it
	function removeShibbolethID(shibbolethID) {
		return discoveryService.mdq(shibbolethID).then(function (entity) {
			if (!entity)
			{
				//Create entity if we can not discover it
				entity  = createDefaultEntity(shibbolethID, '');
			}
			return removeEntity(entity);
		});
	}

	//This call gets the latest shibboleth entities stored in seamless access storage, via a callback function.
	function latestShibboleth() {
		return waitForThiss()
			.then(function (result) {
				if (!isInitialized) {
					initializeSeamless();
				}

				return discoveryService.ps
					.entities(persistenceContext)
					.then(function (res) {
						return res.data.sort(compareByMostRecentLastUse);
					});
			});
	}

	//Persist in the seamless access entity storage
	function saveEntity(entity, preferredTitle) {
		entity.title = preferredTitle;
		
		return discoveryService.ps
			.update(persistenceContext, entity)
			.then(latestShibboleth);
	}

	//Remove from the seamless access entity storage
	function removeEntity(entity, callback) {
		
		return discoveryService.ps
			.remove(persistenceContext, entity.entity_id)
			.then(latestShibboleth);
	}

})(jQuery);
